/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_TitleInputs */

const vi_whats_new_title = /** @type {(inputs: Whats_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có gì mới`)
};

/**

* @param {Whats_New_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const whats_new_title = /** @type {((inputs?: Whats_New_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_whats_new_title(inputs)
});